module.exports = __webpack_public_path__ + "img/dashboard-order.1c417284.svg";